var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 2.5V11.5H3.75V2.5H2.25ZM5.46414 0.644714C5.20343 0.398369 4.86712 0.25 4.5 0.25H1.5C0.671573 0.25 0 1.00552 0 1.9375V12.0625C0 12.9945 0.671573 13.75 1.5 13.75H4.5C4.86712 13.75 5.20343 13.6016 5.46414 13.3553C5.79176 13.0457 6 12.5815 6 12.0625V1.9375C6 1.41852 5.79175 0.954268 5.46414 0.644714ZM8.03586 0.644714C7.70824 0.954268 7.5 1.41852 7.5 1.9375V12.0625C7.5 12.5815 7.70824 13.0457 8.03586 13.3553C8.29657 13.6016 8.63288 13.75 9 13.75H15C15.3671 13.75 15.7034 13.6016 15.9641 13.3553C16.2918 13.0457 16.5 12.5815 16.5 12.0625V1.9375C16.5 1.41852 16.2918 0.954268 15.9641 0.644715C15.7034 0.398369 15.3671 0.25 15 0.25H9C8.63288 0.25 8.29657 0.398369 8.03586 0.644714ZM18.5359 0.644715C18.2082 0.954268 18 1.41852 18 1.9375V12.0625C18 12.5815 18.2082 13.0457 18.5359 13.3553C18.7966 13.6016 19.1329 13.75 19.5 13.75H22.5C23.3284 13.75 24 12.9945 24 12.0625V1.9375C24 1.00552 23.3284 0.25 22.5 0.25H19.5C19.1329 0.25 18.7966 0.398369 18.5359 0.644715ZM9.75 2.5V11.5H14.25V2.5H9.75ZM20.25 2.5V11.5H21.75V2.5H20.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.c1312568902216195e169a6416298d4d.svg";
export { ForwardRef as ReactComponent };